import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
	formBody: {
		flexGrow: 1,
		display: "flex",
		flexDirection: "column",
		padding: "var(--formBodyV) var(--formBodyH)",
	},
}));
